const THEME_ID = "$$biome";
export {
  THEME_ID
};
